/**
 * This function returns an object with properties that are on the hash, but are not received by context
 * @param hash
 * @param contextParams
 * @returns
 */

export const getHashParametersFiltered = (hash: string, contextParams: any): { [key: string]: string } => {
    const paramsKeys = Object.keys(contextParams)
    let regexp = /\?(.*)/
    return hash
        .substr(1)
        .split('&')
        .reduce(function (res, item, idx) {
            const parts = item.split('=')
            if (idx === 0 && regexp.exec(parts[0]).length >= 2 && regexp.exec(parts[0])[1] !== '')
                parts[0] = regexp.exec(parts[0])[1]

            if (paramsKeys.indexOf(parts[0]) === -1) res[parts[0]] = parts[1]
            return res
        }, {})
}
